<template>
  <div class="box-body">
    <div class="table-responsive">
      <div slot="content">

        <div class="col-lg-12 col-md-12 col-sm-12">
          <va-box title="Printer History Records" :isBorder="true" theme="box-warning" widgetType="">
            <div slot="icon-title" class="box-tools" style="float: right; padding: 0px 10px;">

              <div style="padding-left: 0px; padding-bottom: 10px; border-radius: 5px;">
                <div class="col-sm-3">
                  <span>From Date:</span>
                  <input type="date" class="form-control" v-model="filters.fromDate" />
                </div>
                <div class="col-sm-3">
                  <span>To Date:</span>
                  <input type="date" class="form-control" v-model="filters.toDate" min="filters.toDate" />
                </div>
                <div class="col-sm-6" style="padding-top: 22px;">
                  <ul class="pagination pagination-sm inline" style="cursor: pointer; vertical-align: bottom;">
                    <li :class="[options.activeFilter==='Counters' ? 'active' : '']"><a @click="options.activeFilter='Counters'" style="width: 80px!important; text-align: center;">Counters</a></li>
                    <li :class="[options.activeFilter==='Toners' ? 'active' : '']"><a @click="options.activeFilter='Toners'" style="width: 80px!important; text-align: center;">Toners</a></li>
                    <li :class="[options.activeFilter==='Info' ? 'active' : '']"><a @click="options.activeFilter='Info'" style="width: 80px!important; text-align: center;">Info</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div slot="content">

              <div class="col-lg-2 col-md-4 col-sm-12">
                <div class="box-header">
                  <div class="box-title">Printer Info:</div>
                </div>
                <div v-for="item in printerInfo" class="printerInfoItem">
                  <span class="description-text">{{item.title}}:</span>
                  <b class="text-right pull-right">{{item.value}}</b>
                </div>
              </div>

              <div class="col-lg-4 col-md-8 col-sm-12">
                <div class="box-header">
                  <div class="box-title">Toner Replace:</div>
                </div>
                <VueTable style="height: 500px;" :columns="columnsToner" :rows="tonerHistory" :pageSize="100"></VueTable>
              </div>

              <div class="col-lg-6 col-md-8 col-sm-12">
                <div class="box-header">
                  <div class="box-title">Printer History:</div>
                </div>
                <VueTable style="height: 500px;" :columns="columns" :rows="printerHistory" :pageSize="100" :options="options"></VueTable>
              </div>

              <!--<loading :active.sync="loadingPrinter" :is-full-page="isFullpage"></loading>-->

            </div>
          </va-box>
        </div>

        <!--<div class="col-lg-4 col-md-12 col-sm-12">
          <va-box title="Toners Replaced" :isBorder="true" theme="box-warning" widgetType="">
            <VueTable style="height: 500px;" :columns="columns" :rows="printerHistory" :pageSize="100" :options="options"></VueTable>
          </va-box>
        </div>-->

        <div :class="[isFullScreenChart ? 'col-lg-12' : 'col-lg-6', 'col-md-12 col-sm-12']">
          <va-box title="Counters History" :isBorder="true" theme="box-warning" :widgetType="isFullScreenChart ? 'window-restore' : 'window-maximize'" @windowClicked="isFullScreenChart = !isFullScreenChart">
            <div slot="content">
              <va-chart :chart-config='countersChart'></va-chart>
            </div>
          </va-box>
        </div>

        <div :class="[isFullScreenChart ? 'col-lg-12' : 'col-lg-6', 'col-md-12 col-sm-12']">
          <va-box title="Toners History" :isBorder="true" theme="box-warning" :widgetType="isFullScreenChart ? 'window-restore' : 'window-maximize'" @windowClicked="isFullScreenChart = !isFullScreenChart">
            <div slot="content">
              <va-chart :chart-config='tonersChart'></va-chart>
            </div>
          </va-box>
        </div>

        </div>

        <loading :active.sync="isLoading" :is-full-page="isFullpage"></loading>

      </div>
  </div>
  
</template>
<script>

  import Loading from 'vue-loading-overlay'
  import VABox from '../components/VABox'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'
  import VueTable from '../components/Table/DataTable.vue'
  import { db, dbStore } from '../firebase'
  import VAChart from '../components/VAChart'
  import { GetPrintersHistory } from '../plugins/printersHistory.js'

  export default {
    name: 'PrinterHistory',
    components: {
      'loading': Loading,
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-chart': VAChart,
      VueTable
    },
    data () {
      return {
        isPrinterReady: false,
        isFullScreenHistory: true,
        isFullScreenChart: false,
        filters: {
          dealerKey: '',
          customerKey: '',
          siteKey: 'All',
          fromDate: '',
          toDate: '',
          reload: {
            fromDate: '',
            toDate: ''
          },
          startAtValue: '',
          endAtValue: ''
        },
        dealers: [],
        customers: [],
        sites: [],
        options: { showDefault: false, activeFilter: 'Counters' },
        countersTemplate: {
          Total: {
            label: 'Total',
            backgroundColor: '#333333',
            borderColor: '#333333',
            fill: false,
            borderWidth: 1,
            data: []
          },
          A4Black: {
            label: 'A4 Black',
            backgroundColor: '#888888',
            borderColor: '#888888',
            fill: false,
            borderWidth: 1,
            data: []
          },
          A4Color: {
            label: 'A4 Color',
            backgroundColor: '#FF0000',
            borderColor: '#FF0000',
            fill: false,
            borderDash: [5, 5],
            borderWidth: 1,
            data: []
          },
          A3Black: {
            label: 'A3 Black',
            backgroundColor: '#665566',
            borderColor: '#665566',
            fill: false,
            borderWidth: 1,
            data: []
          },
          A3Color: {
            label: 'A3 Color',
            backgroundColor: '#0000FF',
            borderColor: '#0000FF',
            fill: false,
            borderDash: [5, 5],
            borderWidth: 1,
            data: []
          }
        },
        countersChart: {
          type: 'line',
          reload: false,
          data: {
            labels: [],
            datasets: [
              {
                label: 'Total',
                backgroundColor: '#333333',
                borderColor: '#333333',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'A4 Black',
                backgroundColor: '#888888',
                borderColor: '#888888',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'A4 Color',
                backgroundColor: '#FF0000',
                borderColor: '#FF0000',
                fill: false,
                borderDash: [5, 5],
                borderWidth: 1,
                data: []
              },
              {
                label: 'A3 Black',
                backgroundColor: '#665566',
                borderColor: '#665566',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'A3 Color',
                backgroundColor: '#0000FF',
                borderColor: '#0000FF',
                fill: false,
                borderDash: [5, 5],
                borderWidth: 1,
                data: []
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: false
              }],
              yAxes: [{
                stacked: false
              }]
            }
          }
        },
        tonersChart: {
          type: 'line',
          reload: false,
          data: {
            labels: [],
            datasets: [
              {
                label: 'Black',
                backgroundColor: '#333333',
                borderColor: '#333333',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'Magenta',
                backgroundColor: '#CC006B',
                borderColor: '#CC006B',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'Cyan',
                backgroundColor: '#0093D3',
                borderColor: '#0093D3',
                fill: false,
                borderWidth: 1,
                data: []
              },
              {
                label: 'Yellow',
                backgroundColor: '#FFD10C',
                borderColor: '#FFD10C',
                fill: false,
                borderWidth: 1,
                data: []
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: false
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  beginAtZero: true,
                  steps: 10,
                  stepValue: 5,
                  max: 100
                }
              }]
            }
          }
        },
        printerHistory: [],
        tonerHistory: [],
        isColorPrinter: false,
        isA3Printer: false,
        lastUpdate: '',
        currentPrinter: null,
        printerProps: [],
        printerInfo: [],
        printerCounters: [],
        printerStatus: [],
        printerToners: [],
        images: [],
        isFullpage: false,
        loadingImage: false,
        isLoading: false,
        title: '',
        printerType: {
          Key: '',
          ModelName: '',
          ImageUrl: '',
          IsMFC: false,
          IsPrinter: false,
          IsScanner: false,
          IsCopier: false,
          IsFax: false,
          IsColor: false,
          IsBW: false,
          IsA4: false,
          IsA3: false,
          IsDuplex: false
        },
        columns: [
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false, filterKey: 'Info' },
          { fieldName: 'IsUSB', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'PageCount', label: 'Pages', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'Dealer', label: 'Dealer', isSortable: true, isHidden: false, filterKey: 'All', length: 10 },
          { fieldName: 'Customer', label: 'Customer', isSortable: true, isHidden: false, filterKey: 'Info', length: 10 },
          { fieldName: 'Site', label: 'Site', isSortable: true, isHidden: false, filterKey: 'Info', length: 10 },
          { fieldName: 'Status', label: 'Status', isSortable: true, isHidden: false, filterKey: 'Info', length: 20 },
          { fieldName: 'ErrorString', label: 'Error', isSortable: true, isHidden: false, filterKey: 'Info', length: 20 },
          { fieldName: 'A4Black', label: 'A4Black', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'A4Color', label: 'A4Color', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'A3Black', label: 'A3Black', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'A3Color', label: 'A3Color', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'BlackTonerLeft', label: 'Black', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'CyanTonerLeft', label: 'Cyan', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'MagentaTonerLeft', label: 'Magenta', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'YellowTonerLeft', label: 'Yellow', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' }
        ],
        columnsToner: [
          { fieldName: 'Color', label: 'Color', isSortable: false, isHidden: false },
          { fieldName: 'From', label: 'From', isSortable: false, isHidden: false, length: 10 },
          { fieldName: 'StartCounter', label: 'Counter', isSortable: false, isHidden: false, length: 10 },
          { fieldName: 'StartToner', label: 'Toner', isSortable: false, isHidden: false, length: 10 },
          { fieldName: 'To', label: 'To', isSortable: false, isHidden: false, length: 10 },
          { fieldName: 'EndCounter', label: 'Counter', isSortable: false, isHidden: false, length: 10 },
          { fieldName: 'EndToner', label: 'Toner', isSortable: false, isHidden: false, length: 10 }
        ]
      }
    },
    firebase: function () {
      console.log('PrinterHistory firebase()')
      let printerPath = 'Printers/' + this.$route.params.printerKey
      let printerRef = db.ref(printerPath)
      return {
        printer: {
          source: printerRef,
          asObject: true,
          cancelCallback: function () { },
          readyCallback: function () {
            this.initPrinterInfo()
            this.loadTonerHistory()
          }
        }
      }
    },
    created () {
      console.log('PrinterHistory created()')
      this.$root.title = 'Printer'
      this.isLoading = true
      this.filters.fromDate = this.$moment().add(-2, 'months').format('YYYY-MM-DD')
      this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      this.filters.reload.fromDate = this.$moment().add(-2, 'months').format('YYYY-MM-DD')
      this.filters.reload.toDate = this.$moment().format('YYYY-MM-DD')
    },
    mounted () {
      console.log('PrinterHistory mounted()')
    },
    computed: {
      isRefresh () {
        return this.printer && this.printer.IsRefresh === 'Refresh'
      },
      fromDateInt () {
        return Number(this.$moment(this.filters.fromDate).format('YYYYMMDD') + '0000')
      },
      toDateInt () {
        return Number(this.$moment(this.filters.toDate).format('YYYYMMDD') + '2359')
      },
      datesDiff () {
        let diff = -1
        try {
          let fromDate = this.$moment(this.filters.fromDate, 'YYYY-MM-DD')
          let toDate = this.$moment(this.filters.toDate, 'YYYY-MM-DD')
          diff = toDate.diff(fromDate, 'days')
        } catch (e) {
          console.log('computed.datesDiff() error: ' + e.message)
        }
        return diff
      }
    },
    watch: {
      datesDiff (val) {
        this.checkValidFilters()
      },
      isPrinterReady (val) {
        this.checkValidFilters()
      }
    },
    methods: {
      checkValidFilters () {
        if (this.datesDiff >= 0) {
          if (!this.filters.isReload && this.isPrinterReady) {
            console.log('PrinterHistory datesDiff = ' + this.datesDiff)
            this.filters.reload.fromDate = this.filters.fromDate
            this.filters.reload.toDate = this.filters.toDate
            this.filters.startAtValue = this.printer.DealerKey + '_' + this.printer.CustomerKey + '_' + this.fromDateInt
            this.filters.endAtValue = this.printer.DealerKey + '_' + this.printer.CustomerKey + '_' + this.toDateInt
            this.loadPrinterHistory()
          } else {
            this.filters.isReload = false
          }
        } else {
          this.reloadDates()
        }
      },
      reloadDates () {
        this.filters.fromDate = this.filters.reload.fromDate
        this.filters.toDate = this.filters.reload.toDate
        this.filters.isReload = true
      },
      initPrinterInfo () {
        console.log('PrinterHistory initPrinterInfo()...')
        let vm = this
        vm.title = 'Printer ' + '[' + vm.printer.MacAddress + ']'
        vm.title = 'Printer ' + '[' + vm.printer['.key'] + ']'
        vm.title = 'Printer Info'

        let cust = vm.$root.customers.find(c => c.value === vm.printer.CustomerKey)
        if (cust) {
          vm.printer.Customer = cust.title
        }
        let site = vm.$root.sites.find(c => c.value === vm.printer.SiteKey)
        if (site) {
          vm.printer.Site = site.title
        }
        vm.printerInfo = []
        vm.lastUpdate = vm.printer.Logged
        vm.printerInfo.push({ title: 'Update', value: vm.printer.Logged })
        vm.printerInfo.push({ title: 'Serial', value: vm.printer.PrinterSerial })
        vm.printerInfo.push({ title: 'Model', value: vm.printer.ModelName })
        vm.printerInfo.push({ title: 'MAC', value: vm.printer.MacAddress })
        vm.printerInfo.push({ title: 'IP', value: vm.printer.IPAddress })
        vm.printerInfo.push({ title: 'Dealer', value: vm.printer.Dealer })
        vm.printerInfo.push({ title: 'Customer', value: vm.printer.Customer })
        vm.printerInfo.push({ title: 'Site', value: vm.printer.Site })
        vm.printerInfo.push({ title: 'Location', value: vm.printer.Location })
        vm.printerInfo.push({ title: 'Host', value: vm.printer.HostName })
        vm.printerInfo.push({ title: 'Status', value: vm.printer.Status })
        vm.printerInfo.push({ title: 'Message', value: vm.printer.Message })
        vm.isColorPrinter = false
        if (vm.printer.CyanTonerLeft && vm.printer.CyanTonerLeft.length > 0) {
          vm.isColorPrinter = true
        }
        if (vm.printer.MagentaTonerLeft && vm.printer.MagentaTonerLeft.length > 0) {
          vm.isColorPrinter = true
        }
        if (vm.printer.MagentaTonerLeft && vm.printer.MagentaTonerLeft.length > 0) {
          vm.isColorPrinter = true
        }
        if (vm.printer.YellowTonerLeft && vm.printer.YellowTonerLeft.length > 0) {
          vm.isColorPrinter = true
        }
        vm.isA3Printer = false
        if (vm.printer.A3Black && vm.printer.A3Black.length > 0) {
          if (Number(vm.printer.A3Black) > 0) {
            vm.isA3Printer = true
          }
        }
        if (vm.printer.A3Color && vm.printer.A3Color.length > 0) {
          if (Number(vm.printer.A3Color) > 0) {
            vm.isA3Printer = true
          }
        }
        if (vm.isA3Printer) {
          vm.printerInfo.push({ title: 'Size', value: 'A3' })
        } else {
          vm.printerInfo.push({ title: 'Size', value: 'A4' })
        }
        if (vm.isColorPrinter) {
          vm.printerInfo.push({ title: 'Color', value: 'Color' })
        } else {
          vm.printerInfo.push({ title: 'Color', value: 'Monochrome' })
        }

        vm.isPrinterReady = true
        vm.isLoading = false
      },
      loadPrinterHistory () {
        console.log('PrinterHistory loadPrinterHistory()...')
        const vm = this
        vm.resetCharts(vm)
        vm.isLoading = true
        let fromDate = {
          Year: Number(vm.$moment(vm.filters.fromDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.fromDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.fromDate).format('DD')),
          Path: ''
        }
        let toDate = {
          Year: Number(vm.$moment(vm.filters.toDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.toDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.toDate).format('DD')),
          Path: ''
        }

        fromDate.Path = vm.$moment(vm.filters.fromDate).format('YYYY') + '/' + vm.$moment(vm.filters.fromDate).format('MM') + '/'
        toDate.Path = vm.$moment(vm.filters.toDate).format('YYYY') + '/' + vm.$moment(vm.filters.toDate).format('MM') + '/'
        var startDateString = vm.filters.fromDate
        var endDateString = vm.filters.toDate
        var startDate = vm.$moment(startDateString, 'YYYY-MM-DD')
        var endDate = vm.$moment(endDateString, 'YYYY-MM-DD').endOf('month')
        var datesPathList = []
        while (startDate.isBefore(endDate)) {
          datesPathList.push(startDate.format('YYYY/MM/'))
          startDate = startDate.add(1, 'month')
        }
        vm.printerHistory = []
        let fromDateStr = vm.fromDateInt + ''
        let toDateStr = vm.toDateInt + ''
        let historyFilters = {
          fromDate: fromDateStr,
          toDate: toDateStr,
          dealer: vm.printer.DealerKey,
          customers: [],
          datePaths: datesPathList,
          printerMAC: vm.printer.MacAddress
        }

        vm.customers = vm.$root.customers.filter(function (customer) {
          return customer.dealerKey === vm.printer.DealerKey
        })

        for (var c = 0; c < vm.customers.length; c++) {
          if (vm.customers[c] && vm.customers[c].value === vm.printer.CustomerKey) {
            historyFilters.customers.push(vm.customers[c])
            break
          }
        }
        console.log(historyFilters)
        GetPrintersHistory(vm, historyFilters).then(function (result) {
          console.log(result)
          if (result.Success) {
            vm.printerHistory = result.Data
            vm.updateCharts(vm)
          }
          vm.isLoading = false
        }).catch(function (error) {
          console.log(error)
          vm.isLoading = false
        })
      },
      loadTonerHistory () {
        console.log('PrinterHistory loadTonerHistory()...')
        const vm = this
        vm.isLoading = true
        vm.tonerHistory = []
        // /TonerHistory/Dealers/GfRz9vbMH6WycVs7LkOslj4yHch1/Customers/-NO8wb6e4uTk-OvHNNDa/Printers/00-21-B7-13-BF-A2/Toners
        let tonerCollectionPath = ''
        tonerCollectionPath += '/TonerHistory/'
        tonerCollectionPath += 'Dealers/'
        tonerCollectionPath += vm.printer.DealerKey + '/'
        tonerCollectionPath += 'Customers/'
        tonerCollectionPath += vm.printer.CustomerKey + '/'
        tonerCollectionPath += 'Printers/'
        tonerCollectionPath += vm.printer.MacAddress + '/'
        console.log('loadTonerHistory path: ' + tonerCollectionPath)
        dbStore.collection(tonerCollectionPath).doc('Toners').get().then((tonerDoc) => {
          console.log('tonerDoc.exists: ' + tonerDoc.exists)
          if (tonerDoc.exists) {
            let toners = tonerDoc.data()

            if (toners.Black && toners.Black.length > 0) {
              for (let i = 0; i < toners.Black.length; i++) {
                vm.pushTonerRow(vm, 'Black', toners.Black[i])
              }
            }

            if (toners.Cyan && toners.Cyan.length > 0) {
              for (let i = 0; i < toners.Cyan.length; i++) {
                vm.pushTonerRow(vm, 'Cyan', toners.Cyan[i])
              }
            }

            if (toners.Magenta && toners.Magenta.length > 0) {
              for (let i = 0; i < toners.Magenta.length; i++) {
                vm.pushTonerRow(vm, 'Magenta', toners.Magenta[i])
              }
            }

            if (toners.Yellow && toners.Yellow.length > 0) {
              for (let i = 0; i < toners.Yellow.length; i++) {
                vm.pushTonerRow(vm, 'Yellow', toners.Yellow[i])
              }
            }

            console.log('vm.tonerHistory = ')
            console.log(vm.tonerHistory)
          }
        }).catch((error) => {
          console.error('Error getting Toners:', error)
        })
      },
      pushTonerRow (vm, color, toner) {
        let dateLen = '2023-02-16'.length
        let startToner = toner.StartToner
        if (startToner && startToner.length > 0) {
          startToner = startToner.replace('.00', '')
        } else {
          startToner = ''
        }

        let endToner = toner.EndToner
        if (endToner && endToner.length > 0) {
          endToner = endToner.replace('.00', '')
        } else {
          endToner = ''
        }
        vm.tonerHistory.push({
          Color: color,
          From: toner.StartLogged.substring(0, dateLen),
          StartCounter: toner.StartCounter,
          StartToner: startToner,
          To: toner.EndLogged.substring(0, dateLen),
          EndCounter: toner.EndCounter,
          EndToner: endToner
        })
      },
      resetCharts (vm) {
        console.log('resetCharts()...')
        vm.resetCountersChart(vm)
        vm.resetTonersChart(vm)
      },
      resetCountersChart (vm) {
        console.log('resetCountersChart()...')
        vm.countersChart.data.labels = []
        vm.countersChart.data.datasets = []
        vm.countersChart.data.datasets.push({
          label: 'Total',
          backgroundColor: '#333333',
          borderColor: '#333333',
          fill: false,
          borderWidth: 1,
          data: []
        })
        vm.countersChart.data.datasets.push({
          label: 'A4 Black',
          backgroundColor: '#888888',
          borderColor: '#888888',
          fill: false,
          borderWidth: 1,
          data: []
        })

        if (vm.isColorPrinter) {
          vm.countersChart.data.datasets.push({
            label: 'A4 Color',
            backgroundColor: '#FF0000',
            borderColor: '#FF0000',
            fill: false,
            borderDash: [5, 5],
            borderWidth: 1,
            data: []
          })
        }
        if (vm.isA3Printer) {
          vm.countersChart.data.datasets.push({
            label: 'A3 Black',
            backgroundColor: '#665566',
            borderColor: '#665566',
            fill: false,
            borderWidth: 1,
            data: []
          })

          if (vm.isColorPrinter) {
            vm.countersChart.data.datasets.push({
              label: 'A3 Color',
              backgroundColor: '#0000FF',
              borderColor: '#0000FF',
              fill: false,
              borderDash: [5, 5],
              borderWidth: 1,
              data: []
            })
          }
        }
        vm.countersChart.reload = false
      },
      resetTonersChart (vm) {
        console.log('resetTonersChart()...')
        vm.tonersChart.data.labels = []
        vm.tonersChart.data.datasets = []
        vm.tonersChart.data.datasets.push({
          label: 'Black',
          backgroundColor: '#333333',
          borderColor: '#333333',
          fill: false,
          borderWidth: 1,
          data: []
        })
        if (vm.isColorPrinter) {
          vm.tonersChart.data.datasets.push({
            label: 'Magenta',
            backgroundColor: '#CC006B',
            borderColor: '#CC006B',
            fill: false,
            borderWidth: 1,
            data: []
          })
          vm.tonersChart.data.datasets.push({
            label: 'Cyan',
            backgroundColor: '#0093D3',
            borderColor: '#0093D3',
            fill: false,
            borderWidth: 1,
            data: []
          })
          vm.tonersChart.data.datasets.push({
            label: 'Yellow',
            backgroundColor: '#FFD10C',
            borderColor: '#FFD10C',
            fill: false,
            borderWidth: 1,
            data: []
          })
        }
        if (vm.hasA3Printers) {

        }
        vm.tonersChart.reload = false
      },
      updateCharts (vm) {
        console.log('updateCharts()...')
        let limitPrinterHistory = vm.getLimitPrinterHistory(vm)
        // limitPrinterHistory = vm.printerHistory
        console.log(limitPrinterHistory)
        vm.updateCountersCharts(vm, limitPrinterHistory)
        vm.updateTonersCharts(vm, limitPrinterHistory)
      },
      getLimitPrinterHistory (vm) {
        console.log('getLimitPrinterHistory()...')
        console.log('vm.printerHistory.length = ' + vm.printerHistory.length)
        let maxRows = 30
        if (vm.printerHistory.length > maxRows) {
          let resultArr = []
          let delta = Math.floor(vm.printerHistory.length / maxRows)
          for (let i = 0; i < vm.printerHistory.length; i = i + delta) {
            resultArr.push(vm.printerHistory[i])
          }
          return resultArr
        } else {
          return vm.printerHistory
        }
      },
      updateCountersCharts (vm, limitPrinterHistory) {
        console.log('updateCountersCharts()...')
        limitPrinterHistory.forEach(function (prn) {
          if (prn && prn.Logged && prn.Logged.length > 0) {
            let date = vm.$moment(prn.Logged, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')
            console.log(date)
            vm.countersChart.data.labels.push(date)
            vm.countersChart.data.datasets[0].data.push(prn.PageCount)
            vm.countersChart.data.datasets[1].data.push(prn.A4Black)
            if (vm.isColorPrinter) {
              vm.countersChart.data.datasets[2].data.push(prn.A4Color)
              if (vm.isA3Printer) {
                vm.countersChart.data.datasets[3].data.push(prn.A3Black)
                vm.countersChart.data.datasets[4].data.push(prn.A3Color)
              }
            } else {
              if (vm.isA3Printer) {
                vm.countersChart.data.datasets[2].data.push(prn.A3Black)
              }
            }
          }
        })
        vm.countersChart.reload = true
      },
      updateTonersCharts (vm, limitPrinterHistory) {
        console.log('updateTonersCharts()...')
        limitPrinterHistory.forEach(function (prn) {
          if (prn && prn.Logged && prn.Logged.length > 0) {
            let date = vm.$moment(prn.Logged, 'YYYY-MM-DD HH:mm:ss').format('DD/MM')
            console.log(date)
            vm.tonersChart.data.labels.push(date)
            vm.tonersChart.data.datasets[0].data.push((prn.BlackTonerLeft >= 0) ? prn.BlackTonerLeft : 0)
            if (vm.isColorPrinter) {
              vm.tonersChart.data.datasets[1].data.push((prn.MagentaTonerLeft >= 0) ? prn.MagentaTonerLeft : 0)
              vm.tonersChart.data.datasets[2].data.push((prn.CyanTonerLeft >= 0) ? prn.CyanTonerLeft : 0)
              vm.tonersChart.data.datasets[3].data.push((prn.YellowTonerLeft >= 0) ? prn.YellowTonerLeft : 0)
            }
          }
        })
        vm.tonersChart.reload = true
      }
    }
  }
</script>

<style>
  .printerInfoItem {
    width: auto;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    padding-right: 10px;
    /*float: left;*/
    background-color: #f5f5f5;
  }
</style>




// WEBPACK FOOTER //
// PrinterHistory.vue?2c6b10e3